import type { NavigateOptions } from '@tanstack/react-router';

const NAVBAR_HEIGHT = 78;

function scrollToElement(id: string, smooth = true) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT;
  window.scrollTo({ top, behavior: smooth ? 'smooth' : 'instant' });
}

/**
 * If on the home page, smooth scrolls to the section (offset by navbar height).
 * Otherwise, navigates to `/#section` so the home page can scroll on mount.
 */
export function scrollToSection(hash: string, navigate: (opts: NavigateOptions) => void) {
  const sectionId = hash.replace('#', '');
  const isHome = window.location.pathname === '/';

  if (isHome) {
    scrollToElement(sectionId);
  } else {
    navigate({ to: '/', hash });
  }
}

export { scrollToElement };
